import { telephone } from "@simplybusiness/icons";
import { Button, Icon, Text } from "@simplybusiness/mobius";
import { getPhoneNumber } from "./phoneNumbers";

export const getCallOrChatVariant = (
  contactVariant: string,
  vertical: string,
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
  fireEvent: ((eventName: string) => void) | undefined,
) => {
  const handleChatClick = () => {
    if (window?.zE) {
      setIsOpen(false);
      fireEvent?.("qcp_modal_chat_opened");
      window.zE("messenger", "show");
      window.zE("messenger", "open");
    }
  };
  const phoneNumber = getPhoneNumber(vertical);

  switch (contactVariant) {
    case "call":
      return (
        <>
          <div className="qcp-inactivity-intervention__qcp-phone-number qcp-inactivity-intervention__desktop-only">
            <Icon
              icon={telephone}
              size="md"
              color="var(--color-bubblegum-500)"
            />
            <Text
              className="qcp-inactivity-intervention__qcp-phone-number-text"
              elementType="h3"
            >
              {phoneNumber.display}
            </Text>
          </div>
          <a href={`tel:${phoneNumber.href}`}>
            <Button
              data-testid="qcp-inactivity-call-us-button"
              className="qcp-inactivity-intervention__button qcp-inactivity-intervention__mobile-only"
              variant="primary"
              size="sm"
              onClick={() => {
                fireEvent?.("qcp_modal_phone_call_opened");
              }}
            >
              Call Us
            </Button>
          </a>
        </>
      );
    case "chat":
      return (
        <Button
          data-testid="qcp-inactivity-chat-button"
          className="qcp-inactivity-intervention__button qcp-inactivity-intervention__agent-chat-button"
          variant="primary"
          size="sm"
          onClick={handleChatClick}
        >
          Chat With an Agent
        </Button>
      );
  }
};

export const getInterventionTitle = (type: string) => {
  switch (type) {
    case "wc":
      return "Let's review your Workers' Comp quotes together!";
    case "gl":
      return "Let's review your General Liability quotes together!";
    case "generic":
      return (
        <>
          Let&#39;s review your quotes
          <br />
          together!
        </>
      );
  }
};

export const getTrade = (trade: string) => {
  trade = trade.toLowerCase();
  switch (trade) {
    case "handyperson":
      trade = "handyman";
      break;
    case "janitorial services":
      trade = "janitorial";
      break;
    case "painting and wall covering contractors":
      trade = "painting & wallpaper";
      break;
    case "trucking & transportation services":
      trade = "trucking & transportation";
      break;
    case "landscaping services":
      trade = "landscaping";
      break;
    case "general contractor":
      trade = "general contracting";
      break;
  }
  return trade;
};
